<template>
  <div id="wrap-drawer">
    <div id="wrap-content">

      <div id="search-drawer">
        <v-text-field
          v-model="search_keyword"
          hide-details
          solo flat
          background-color="grey lighten-5"
          clearable
          single-line
          append-icon="mdi-magnify"
          placeholder="search...">
        </v-text-field>
      </div>

      <div id="toolbar-drawer">

        <div id="toolbar-drawer-left" v-if="edit_mode">
          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn small icon color="#c1c3c9" v-on="on" @click="all_selected=!all_selected">
                  <v-icon v-if="part_selected">mdi-minus-box</v-icon>
                  <v-icon v-else-if="all_selected">mdi-checkbox-marked</v-icon>
                  <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                </v-btn>
              </template>
              <span>모두 선택하기</span>
            </v-tooltip>
          </div>
          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn small icon color="#c1c3c9" v-on="on"
                  @click.stop="copyDocuments()"
                  :disabled="!checked_docs.length">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>다른 프로젝트로 복사/이동하기</span>
            </v-tooltip>
          </div>
          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn small icon color="#c1c3c9" v-on="on"
                  :disabled="!checked_docs.length"
                  @click="temp_keys=checked_docs;remove_dialog=true">
                  <v-icon>mdi-trash-can</v-icon>
                </v-btn>
              </template>
              <span>프로젝트에서 제거하기</span>
            </v-tooltip>
          </div>
          <div>
            <v-btn @click="edit_mode=false"
              rounded depressed small dark color="#485158">
              편집 완료
            </v-btn>
          </div>
        </div>

        <div id="toolbar-drawer-left" v-else>
          <!-- View mode -->
          <div>
            <v-tooltip bottom v-if="view_mode=='table'">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" color="#c1c3c9"
                  @click="view_mode='card'">
                  <v-icon>mdi-view-module</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('doc_list.card_view') }}</span>
            </v-tooltip>
            <v-tooltip bottom v-if="view_mode=='card'">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" color="#c1c3c9"
                  @click="view_mode='table'">
                  <v-icon>mdi-view-list</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('doc_list.list_view') }}</span>
            </v-tooltip>
          </div>

          <!-- Sort -->
          <div>
            <v-menu offset-y :disabled="visible_docs.length<=1">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn icon color="#c1c3c9">
                    <v-icon>mdi-sort-descending</v-icon>
                  </v-btn>
                </div>
              </template>
              <v-list dense>
                <v-list-item @click="sort_by=sort_by==1?0:1">
                  <v-list-item-content>
                    {{ $t('sorting.title') }}
                  </v-list-item-content>
                  <v-list-item-icon small>
                    <v-icon v-if="sort_by==0" color="#766BFF">mdi-arrow-up</v-icon>
                    <v-icon v-if="sort_by==1" color="#766BFF">mdi-arrow-down</v-icon>
                  </v-list-item-icon>
                </v-list-item>
                <v-list-item @click="sort_by=sort_by==3?2:3">
                  <v-list-item-content>
                    {{ $t('sorting.date') }}
                  </v-list-item-content>
                  <v-list-item-icon small>
                    <v-icon v-if="sort_by==2" color="#766BFF">mdi-arrow-up</v-icon>
                    <v-icon v-if="sort_by==3" color="#766BFF">mdi-arrow-down</v-icon>
                  </v-list-item-icon>
                </v-list-item>
                <v-list-item @click="sort_by=sort_by==5?4:5">
                  <v-list-item-content>
                    {{ $t('sorting.author') }}
                  </v-list-item-content>
                  <v-list-item-icon small>
                    <v-icon v-if="sort_by==4" color="#766BFF">mdi-arrow-up</v-icon>
                    <v-icon v-if="sort_by==5" color="#766BFF">mdi-arrow-down</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <!-- Star -->
          <div v-if="route_name=='project'&&docs_mode==0&&!is_inactive">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon small @click="star_selected=!star_selected" v-on="on"
                  :disabled="!sorted_docs.filter(v=>!!v.star).length">
                  <v-icon v-if="star_selected" color="#ffbf51">mdi-star</v-icon>
                  <v-icon v-else color="#bac2cc">mdi-star-outline</v-icon>
                </v-btn>
              </template>
              <span>중요 도큐먼트만</span>
            </v-tooltip>
          </div>

          <!-- Tag -->
          <div v-if="route_name=='project'&&docs_mode==0&&!is_inactive">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon small @click="tag_selected=!tag_selected" v-on="on"
                  :disabled="!sorted_docs.filter(v=>!!v.tags).length">
                  <v-icon v-if="tag_selected" color="#ff6672">mdi-tag</v-icon>
                  <v-icon v-else color="#bac2cc">mdi-tag-outline</v-icon>
                </v-btn>
              </template>
              <span>태그 도큐먼트만</span>
            </v-tooltip>
          </div>

          <div v-if="docs_mode==0&&!is_inactive">
            <v-menu offset-y id="title-drawer-menu">
              <template v-slot:activator="{ on: { click } }">
                <div v-on:click.stop.prevent="click">
                  <v-btn small icon color="#c1c3c9">
                    <v-icon small>mdi-dots-vertical</v-icon>
                  </v-btn>
                </div>
              </template>
              <v-list dense>
                <v-list-item v-if="route_name=='project'&&docs_mode==0" 
                  @click="edit_mode=true">
                  <div>리스트 편집하기</div>
                </v-list-item>
                <v-list-item>
                  <div>추출하기 (준비중)</div>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>

        <div id="toolbar-drawer-right">
          <div>
            <span>{{ index_page * num_docs_page + 1 }}</span>
            <span>-</span>
            <span v-if="(index_page + 1) * num_docs_page>num_docs">{{ num_docs }}</span>
            <span v-else>{{ (index_page + 1) * num_docs_page }}</span>
            <span>/</span>
            <span>{{ num_docs }}</span>
          </div>
          <div v-if="num_pages>1">
            <v-btn icon small @click="index_page-=1" :disabled="index_page==0">
              <v-icon color="#bac2cc">mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn icon small @click="index_page+=1" :disabled="index_page+1==num_pages">
              <v-icon color="#bac2cc">mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Documents -->
      <div id="documents">
        <div id="wrap-doc-cards" v-if="view_mode=='card'">

          <div class="doc-card" v-for="(doc, index) in visible_docs" :key="index"
            @mouseenter="setHoveredKey(doc.key)">

            <div class="doc-card-content-wrap">
              <div class="doc-card-content">
                <div class="card-header">
                  <div class="header-title">
                    <div v-if="edit_mode">
                      <v-btn small icon color="#c1c3c9" @click="checkDoc(doc.key)">
                        <v-icon v-if="!checked_docs.includes(doc.key)">mdi-checkbox-blank-outline</v-icon>
                        <v-icon v-else>mdi-checkbox-marked</v-icon>
                      </v-btn>
                    </div>
                    <div class="doctype-dot-wrap">
                      <div :style="setColor(doc.doc_type)" class="doctype-dot"></div>
                    </div>
                    <div @click="selectDocument(doc.key)" class="link-element">
                      {{ doc.title }}
                      <!-- <v-clamp autoresize :max-lines="1"></v-clamp> -->
                    </div>
                  </div>
                </div>

                <div>
                  <!-- TODO: authors ...으로 만들기 -->
                  <div class="card-meta">{{ doc.authors_iso690 }}({{ doc.date }})</div>
                  <div class="card-detail">
                    <span v-if="!!doc.publication">{{ doc.publication }}</span>
                    <span v-if="!!doc.number">{{ doc.number }}</span>
                    <span v-if="!!doc.publisher">
                      <span v-if="!!doc.publication||!!doc.number"> - </span>
                      <span>{{ doc.publisher }}</span>
                    </span>
                  </div>
                </div>

                <div class="card-footer">
                  <div v-if="doc.num_refs>0" class="with-reference">
                    {{ $t('doc_list.references') }} {{ doc.num_refs }}
                  </div>
                  <v-btn v-if="route_name=='project'&&!!doc.has_note"
                    @click="openNote(doc.key, !doc.note_opened)"
                    depressed small class="review-button" color="rgb(255, 150, 40, 0.1)">
                    <span v-if="open_docs.includes(doc.key)"><v-icon>mdi-chevron-up</v-icon>리뷰 닫기</span>
                    <span v-else><v-icon>mdi-chevron-down</v-icon>리뷰 펼치기</span>
                  </v-btn>
                </div>
              </div>

              <div class="header-icons" v-if="route_name=='project'&&docs_mode==0">

                <v-btn icon x-small :disabled="is_inactive"
                  @click="setStar(doc.key, doc.star==0?1:0)">
                  <v-icon class="star-visible" v-if="!!doc.star" color="#ffbf51">mdi-star</v-icon>
                  <v-icon class="star-invisible" v-else color="#bac2cc">mdi-star-outline</v-icon>
                </v-btn>

                <div id="tag">
                  <v-menu offset-x :disabled="is_inactive">
                    <template v-slot:activator="{ on: { click } }">
                      <div v-on:click.stop.prevent="click">
                        <v-btn x-small icon>
                          <v-icon small class="tag-visible" v-if="!!doc.tags" :color="doc.tags">mdi-tag</v-icon>
                          <v-icon small class="tag-invisible" v-else color="#bac2cc">mdi-tag-outline</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <v-list dense>
                      <v-list-item @click="setTags(doc.key, '')">
                        <div><v-icon small>mdi-tag-outline</v-icon></div>
                      </v-list-item>
                        <v-list-item v-for="(item, index) in project_tags" :key="index"
                          @click="setTags(doc.key, item)">
                          <div><v-icon small :style="{'color': item}">mdi-tag</v-icon></div>
                        </v-list-item>
                    </v-list>
                  </v-menu>
                </div>

                <div class="more">
                  <v-menu offset-y :disabled="is_inactive">
                    <template v-slot:activator="{ on: { click } }">
                      <div v-on:click.stop.prevent="click">
                        <v-btn x-small icon color="#c1c3c9">
                          <v-icon color="#bac2cc">mdi-dots-vertical</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <v-list dense>
                      <v-list-item @click="temp_keys=[doc.key];remove_dialog=true">
                        <div>프로젝트에서 제거하기</div>
                      </v-list-item>
                      <!-- <v-list-item @click="temp_keys=[doc.key];report_issue_visible=true">
                        <div>도큐먼트 정보 신고하기</div>
                      </v-list-item> -->
                    </v-list>
                  </v-menu>
                </div>

              </div>
            </div>

            <div class="card-docnote" v-show="open_docs.includes(doc.key)"
              @click="selectDocument(doc.key)">
              <div v-if="doc.note_content=='merged'" class="card-docnote-content empty-docnote">
                이 도큐먼트는 다른 도큐먼트와 병합되었습니다. 자세한 사항은 여기를 클릭해 도큐먼트 상세 정보에서 확인하시기 바랍니다.
              </div>
              <div v-else-if="!parseNote(doc.note_content)" class="card-docnote-content empty-docnote">
                Waiting your review...
              </div>
              <div v-else class="card-docnote-content" v-html="parseNote(doc.note_content)"></div>
            </div>

          </div>

        </div>

        <div id="wrap-doc-table" v-else>

          <!-- Table header -->
          <div id="doc-table-header">
            <div class="table-row" 
              :class="{'table-row-project': docs_mode!=0, 'table-row-watching': route_name!='project'}">
              <div class="row-type"></div>
              <div class="row-title">{{ $t('doc_info.title') }}</div>
              <div class="row-authors">{{ $t('doc_info.authors') }}</div>
              <div class="row-date">{{ $t('doc_info.date') }}</div>
              <div class="row-note" v-if="route_name=='project'">{{ $t('doc_info.note') }}</div>
              <div class="row-star" v-if="route_name=='project'&&docs_mode==0">{{ $t('doc_info.star') }}</div>
              <div class="row-tags" v-if="route_name=='project'&&docs_mode==0">{{ $t('doc_info.tag') }}</div>
              <div v-if="route_name=='project'&&docs_mode==0"></div>
            </div>
          </div>

          <!-- Table contents -->
          <div id="doc-table-contents">
            <div class="table-contents"
              v-for="(doc, index) in visible_docs" :key="index">
              <div class="table-row" 
                :class="{'table-row-project': docs_mode!=0, 'table-row-watching': route_name!='project'}"
                @click="selectDocument(doc.key)">
                <div class="doctype-dot-wrap row-type" v-if="!edit_mode">
                  <div :style="setColor(doc.doc_type)" class="doctype-dot"></div>
                </div>
                <div v-else>
                  <v-btn small icon color="#c1c3c9" @click.stop="checkDoc(doc.key)">
                    <v-icon v-if="!checked_docs.includes(doc.key)">mdi-checkbox-blank-outline</v-icon>
                    <v-icon v-else>mdi-checkbox-marked</v-icon>
                  </v-btn>
                </div>
                <div class="row-title">{{ doc.title }}</div>
                <div class="row-authors">{{ doc.authors_iso690 }}</div>
                <div class="row-date">{{ doc.date }}</div>
                <div class="row-note" v-if="route_name=='project'">
                  <v-btn v-if="doc.has_note" icon x-small @click.stop="openNote(doc.key, !doc.note_opened)">
                    <v-icon v-if="open_docs.includes(doc.key)" color="#ff9628">mdi-note-multiple</v-icon>
                    <v-icon v-else color="#ff9628">mdi-note-multiple-outline</v-icon>
                  </v-btn>
                </div>
                <div class="row-star" v-if="route_name=='project'&&docs_mode==0">
                  <v-btn :disabled="is_inactive"
                    icon x-small @click.stop="setStar(doc.key, doc.star==0?1:0)">
                    <v-icon class="star-visible" v-if="!!doc.star" color="#ffbf51">mdi-star</v-icon>
                    <v-icon class="star-invisible" v-else color="#bac2cc">mdi-star-outline</v-icon>
                  </v-btn>
                </div>
                <div class="row-tags" v-if="route_name=='project'&&docs_mode==0">
                  <v-menu offset-x :disabled="is_inactive">
                    <template v-slot:activator="{ on: { click } }">
                      <div v-on:click.stop.prevent="click">
                        <v-btn x-small icon>
                          <v-icon small class="tag-visible" v-if="!!doc.tags" :color="doc.tags">mdi-tag</v-icon>
                          <v-icon small class="tag-invisible" v-else color="#bac2cc">mdi-tag-outline</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <v-list dense :disabled="is_inactive">
                      <v-list-item @click.stop="setTags(doc.key, '')">
                        <div><v-icon small>mdi-tag-outline</v-icon></div>
                      </v-list-item>
                        <v-list-item v-for="(item, index) in project_tags" :key="index"
                          @click.stop="setTags(doc.key, item)">
                          <div><v-icon small :style="{'color': item}">mdi-tag</v-icon></div>
                        </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
                <div class="row-more" v-if="route_name=='project'&&docs_mode==0">
                  <v-menu offset-y :disabled="is_inactive">
                    <template v-slot:activator="{ on: { click } }">
                      <div v-on:click.stop.prevent="click">
                        <v-btn x-small icon color="#c1c3c9">
                          <v-icon color="#bac2cc">mdi-dots-vertical</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <v-list dense>
                      <v-list-item @click="temp_keys=[doc.key];remove_dialog=true">
                        <div>프로젝트에서 제거하기</div>
                      </v-list-item>
                      <!-- <v-list-item @click="temp_keys=[doc.key];report_issue_visible=true">
                        <div>도큐먼트 정보 신고하기</div>
                      </v-list-item> -->
                    </v-list>
                  </v-menu>
                </div>
              </div>
              <div class="card-docnote" v-show="open_docs.includes(doc.key)"
                @click="selectDocument(doc.key)">
                <div v-if="!parseNote(doc.note_content)" class="card-docnote-content empty-docnote">
                  Waiting your review...
                </div>
                <div v-else class="card-docnote-content" v-html="parseNote(doc.note_content)"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modals -->
    <!-- <modal-report-issue-doc
      :dialog.sync="report_issue_visible"
      :doc="temp_doc">
    </modal-report-issue-doc> -->

    <modal-copy-documents
      :dialog.sync="copy_documents_visible"
      :projid="proj_id"
      :dockey="checked_docs"
      :editmode.sync="edit_mode">
    </modal-copy-documents>

    <!-- Remove Dialog -->
    <template>
      <v-dialog v-model="remove_dialog" width="400px">
        <v-card>
          <v-card-title class="card-title-wrapper">
            <span>도큐먼트를 제거하시겠습니까?</span>
            <v-btn icon @click="temp_keys=[];remove_dialog=false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            도큐먼트를 프로젝트에서 제거하더라도 <a href="/reviews" target="_blank">리뷰 페이지</a>에서 작성하신 도큐먼트 리뷰를 확인하실 수 있습니다.
          </v-card-text>
          <v-card-text v-if="!!project_info.num_docs">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-checkbox 
                    color="primary"
                    v-model="to_clip"
                    label="제거할 도큐먼트를 클립에 보관하기"
                    :disabled="user_type='basic'"
                  ></v-checkbox>
                </div>
              </template>
              <div>프리미엄 기능입니다</div>
            </v-tooltip>
          </v-card-text>
          <v-card-actions>
            <v-btn small block depressed color="primary"
              @click="removeDocuments()">
              {{ $t('doc_list.remove') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

  </div>
</template>

<script>
import VClamp from 'vue-clamp'
import { mapGetters, mapMutations } from 'vuex'
import { sortDocuments, returnDocDetail } from '../../../custom/function'
import { coloring } from "../../../custom/fn_color"
import { sort_opts, doc_types, project_tags } from '../../../custom/model'

export default {

  components: {
    VClamp,
  },

  props: {
    docs_mode: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      sort_opts,
      doc_types,
      project_tags,

      sort_by: 4,

      edit_mode: false,
      checked_docs: [],
      all_selected: false,

      copy_documents_visible: false,

      set_docs: [],
      sorted_docs: [],
      filtered_docs: [],
      visible_docs: [],
      checked_docs: [],

      num_docs: 0,
      num_pages: 0,
      index_page: 0,
      num_docs_page: 50,

      star_selected: false,
      tag_selected: false,

      temp_keys: [],
      remove_dialog: false,
      to_clip: true,
      // report_issue_visible: false,

      open_docs: [],
      view_mode: 'card',

      search_keyword: '',
    }
  },
  
  computed: {
    ...mapGetters({
      project_info: 'project/project_info',
      proj_docs: 'project/documents',
      watching_project_info: 'watching/project_info',
      watching_proj_docs: 'watching/documents',
      vertex_docs: 'tree/documents',
      sg_keys: 'tree/sg_keys',
      vertex_library: 'tree/vertex_library',
      changed_doc_key: 'notes/changed_doc_key',
      user_type: 'user/user_type',
    }),

    route_name() {
      return this.$route.name
    },

    proj_id() {
      return parseInt(this.$route.params.id)
    },

    vid() {
      return this.$route.query.vid
    },

    num_proj_docs() {
      return this.proj_docs.length
    },

    part_selected() {
      return this.checked_docs.length != this.visible_docs.length && !!this.checked_docs.length
    },

    is_inactive() {
      return this.project_info.status >= 10
    },
  },

  watch: {
    docs_mode: {
      handler(val) {
        this.setDocs()
        this.search_keyword = ''
      },
      immediate: true,
    },

    num_proj_docs: {
      handler(val) {
        this.setDocs()
        this.checked_docs = []
        this.search_keyword = ''
      }
    },

    proj_docs: {
      handler(docs, old_docs) {
        let vm = this
        if (!!docs.length && docs.length == old_docs.length) {
          docs.forEach(doc => {
            let sorted_doc = vm.sorted_docs.filter(v => v.key==doc.key)[0]
            // Star & tags
            sorted_doc.star = doc.star
            sorted_doc.tags = doc.tags
            // Note
            sorted_doc.has_note = doc.has_note
            if (!doc.has_note) { this.openNote(doc.key, false) }
          })
        }
      },
      deep: true,
    },

    changed_doc_key(val) {
      if (!!val) {
        let index = this.sorted_docs.findIndex(obj => obj.key == val)
        if (this.sorted_docs[index].note_opened) {
          this.openNote(val, true)
        }
        this.$store.commit('notes/setChangedDocKey', null)
      }
    },

    vertex_docs: {
      handler(val) {
        this.setDocs()
      }
    },

    vid(val) {
      if (!!val) {
        this.setDocs()
      }
    },

    sort_by(val) {
      this.updateDocs(this.sorted_docs, val)
    },

    star_selected(val) {
      if (val) {
        this.filtered_docs = this.tag_selected ?
          this.sorted_docs.filter(v => !!v.star|!!v.tags) :
          this.sorted_docs.filter(v => !!v.star)
      } else {
        this.filtered_docs = this.tag_selected ?
          this.sorted_docs.filter(v => !!v.tags) :
          this.sorted_docs
      }
    },

    tag_selected(val) {
      if (val) {
        this.filtered_docs = this.star_selected ?
          this.sorted_docs.filter(v => !!v.star|!!v.tags) :
          this.sorted_docs.filter(v => !!v.tags)
      } else {
        this.filtered_docs = this.star_selected ?
          this.sorted_docs.filter(v => !!v.star) :
          this.sorted_docs
      }
    },

    index_page: {
      handler(val) {
        this.updateVisibleDocs()
      },
      immediate: true,
    },

    filtered_docs(val) {
      this.num_docs = val.length
      this.num_pages = Math.ceil(this.num_docs/this.num_docs_page)
      if (this.index_page>=this.num_pages) { this.index_page = 0 }
      this.updateVisibleDocs()
    },

    all_selected(val) {
      if (val && this.checked_docs.length != this.visible_docs.length) {
        this.checked_docs = this.visible_docs.map(v => v.key)
      } else if (!val && !!this.checked_docs.length) {
        this.checked_docs = []
      }
    },

    search_keyword: {
      handler(val) {
        if(!val || !val.length) {
          this.filtered_docs = JSON.parse(JSON.stringify(this.sorted_docs))
        } else {
          this.searchList(val)
        }
      }
    }
  },

  methods: {
    returnDocDetail,
    sortDocuments,
    coloring,

    ...mapMutations({
      showExpiredModal: 'modal/showExpired',
      showAddDocumentsModal: 'modal/showAddDocuments',
      setOnSg: 'tree/setOnSg',
    }),

    setDocs() {
      let vm = this
      let docs = []
      if (this.docs_mode==0) {
        this.set_docs = this.$route.name == 'project' ? 
          this.proj_docs : this.watching_proj_docs
        if (!!this.set_docs.length) {
          this.set_docs.forEach(doc => {
            docs.push(vm.returnDocDetail(doc, doc.doc_type))
          })
        }
        this.setOnSg(false)
      } else {
        if (!!this.vertex_docs.length) {
          this.vertex_docs.forEach(doc => {
            doc.key = doc.doc_key;doc.date=doc.year
          })
          if (this.docs_mode==1) {
            this.setOnSg(false)
            docs = JSON.parse(JSON.stringify(this.vertex_docs))
          } else if (this.docs_mode==2) {
            this.setOnSg(true)
            docs = this.vertex_docs.filter(v => vm.sg_keys.includes(v.key))
          } else if (this.docs_mode==3) {
            this.setOnSg(false)
            let node_keys = this.vertex_library[this.vid].nodes
            docs = this.vertex_docs.filter(v => node_keys.includes(v.key))
          }
          
        }
      }
      this.updateDocs(docs, this.sort_by)
    },

    updateDocs(docs, sort_by) {
      this.search_keyword = ''
      if (!!docs.length) {
        this.sorted_docs = this.sortDocuments(docs, parseInt(sort_by))
        this.sorted_docs.forEach(doc => doc.note_opened = false)
        // Modify filtered_docs
        if (this.star_selected) {
          this.filtered_docs = this.sorted_docs.filter(v => !!v.star)
        } else if (this.tag_selected) {
          this.filtered_docs = this.sorted_docs.filter(v => !!v.tags)
        } else {
          this.filtered_docs = this.sorted_docs
        }
      } else {
        this.sorted_docs = []
        this.filtered_docs = []
      }
    },

    updateVisibleDocs() {
      this.initialize()
      this.visible_docs = 
        this.filtered_docs.slice(this.index_page*this.num_docs_page, (this.index_page+1)*this.num_docs_page)
    },

    showAddDocuments() {
      if (this.is_inactive) {
        this.showExpiredModal()
      } else {
        this.showAddDocumentsModal()
        this.$analytics.logEvent('click', { name: 'project_btn_openAddDocuments' })
      }
    },

    searchList(keyword) {
      keyword = keyword.toLowerCase()
      this.filtered_docs = this.sorted_docs.filter(v => {
        var note = !!v.note ? (!!this.parseNote(v.note.note) ? this.parseNote(v.note.note) : "") : ""
        return v.authors_iso690.toLowerCase().includes(keyword) ||
          (!!v.date && v.date.toLowerCase().includes(keyword)) ||
          note.includes(keyword) ||
          v.title.toLowerCase().includes(keyword)
      })
    },

    setColor(doc_type) {
      let color = this.doc_types[doc_type].color
      return 'background-color:'+ color
    },

    async setStar(key, star) {
      this.$store.commit('project/setStar', { key, star })
      // TODO: error handling
      await this.$store.dispatch('project/setStar', {
        proj_id: this.proj_id,
        doc_key: key,
        star: star
      })
    },

    async setTags(key, tags) {
      this.$store.commit('project/setTags', { key, tags })
      // TODO: error handling
      await this.$store.dispatch('project/setStar', {
        proj_id: this.proj_id,
        doc_key: key,
        tags: tags
      })
    },

    selectDocument(key) {
      let to = { name: this.route_name, query: { doc: key } }
      if (!!this.vid) {
        to = { query: { name: this.route_name, doc: key, vid: this.vid } }
      }
      this.$router.push(to)
    },

    setHoveredKey(key) {
      if (!!this.vertex_docs) {
        this.$store.commit('project/setHoveredKey', key)
      }
    },

    async removeDocuments() {
      try {
        if (this.to_clip&&this.user_type!='basic') {
          let projects = this.$store.getters['project/projects']
          let clip_id = JSON.parse(JSON.stringify(projects.filter(v => v.mode == 9)[0])).proj_id
          await this.$store.dispatch('project/addCopyDocumentsToProject', {
            proj_id: clip_id,
            documents: this.temp_keys,
          })
        }
        await this.$store.dispatch('project/removeDocumentsFromProject', {
          proj_id: this.$route.params.id,
          documents: this.temp_keys,
        })
      } finally {
        this.initialize()
        this.remove_dialog = false
      }
    },

    initialize() {
      // console.log('initialize')
      this.temp_keys = null
      this.all_selected = false
      this.checked_docs = []
      this.edit_mode = false
    },

    parseNote(note) {
      if (note == null) { return null }
      else {
        let html_txt = JSON.parse(note).data
        return html_txt == '<p></p>' ? null : html_txt
      }
    },

    async openNote(key, note_opened) {
      let index = this.sorted_docs.findIndex(obj => obj.key == key)
      this.sorted_docs[index].note_opened = note_opened
      if (note_opened) {
        try {
          await this.$store.dispatch('document/getDocumentNote', key)
        } // TODO: error handling
        finally {
          let note_content = this.$store.getters['document/note']
          // console.log('note_content', note_content)
          if (Array.isArray(JSON.parse(note_content))) {
            this.sorted_docs[index].note_content = 'merged'
          } else {
            this.sorted_docs[index].note_content = note_content
          }
          this.open_docs.push(key)
        }
      } else {
        let remove_index = this.open_docs.indexOf(key)
        if (remove_index !== -1) {
          this.open_docs.splice(remove_index, 1)
        }
      }
    },

    copyDocuments() {
      this.copy_documents_visible = true
    },

    checkDoc(key) {
      if (this.checked_docs.includes(key)) {
        let remove_index = this.checked_docs.indexOf(key)
        if (remove_index !== -1) {
          this.checked_docs.splice(remove_index, 1)
        }
      } else {
        this.checked_docs.push(key)
      }
    },
  },

}
</script>

<style scoped>
  #wrap-drawer {
    height: calc(100vh - 60px - 60px);
  }

  #wrap-content {
    display: flex;
    flex-direction: column;
  }

  /* Search */

  #search-drawer {
    display: flex;
    align-items: center;
    height: 60px;
    padding: 0 30px;
  }

  /* Toolbar */

  #toolbar-drawer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    padding: 0 30px;
  }

  #toolbar-drawer-left, #toolbar-drawer-right {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  #toolbar-drawer-left > div {
    display: flex;
    align-items: center;
    margin-right: 8px;
  }

  #toolbar-drawer-right {
    color: #858d97;
  }

  /* Documents */

  #documents {
    height: calc(100vh - 60px - 120px - 40px);
    overflow-y: auto;
  }

  /* Card */

  .doc-card:hover {
    background-color: #fafafb;
  }

  .doc-card-content-wrap {
    padding: 15px 25px 5px 25px;
    /* width: 100%; */
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .doc-card-content {
    /* width: 100%; */
  }

  .card-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /* width: 100%; */
  }

  .header-icons {
    display: flex;
    flex-direction: column;
    align-content: center;
  }

  .doc-card .star-invisible, .doc-card .tag-invisible, .doc-card .more {
    visibility: hidden;
  }

  .doc-card:hover .star-invisible, .doc-card:hover .tag-invisible, #tag:hover .tag-invisible,  .doc-card:hover .more {
    visibility: visible;
  }

  .header-title {
    font-size: 14px;
    font-weight: 600;
    display: flex;
    flex-direction: row;
    /* width: 100%; */
  }

  .doctype-dot-wrap {
    width: 10px;
    margin-right: 6px;
  }

  .doctype-dot {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    display: inline-block;
  }

  .card-meta {
    margin: 6px 0 0 15px;
    color: #858d97;
  }

  .card-detail {
    margin: 4px 0 0 15px;
    color: rgb(97, 85, 80);
    font-style: italic;
  }

  .card-footer {
    margin: 6px 0 0 15px;
    color: #858d97;
  }

  .with-reference {
    margin-bottom: 6px;;
  }

  .review-button {
    font-size: 11px;
    font-weight: 500;
    color: #ff9628 !important;
  }

  /* card-doc-note */

  .card-docnote {
    background-color: rgb(255, 150, 40, 0.1);
    margin-top: 6px;
    cursor: pointer;
  }

  .card-docnote-content {
    padding: 20px 30px;
  }

  .empty-docnote {
    color: #858d97;
    font-style: italic;
  }

  /* Table */
  #wrap-doc-table {
    padding: 0 30px;
    margin-bottom: 30px;
  }

  #doc-table-header {
    display: flex;
    flex-direction: column;
    border-bottom: solid 1px #818387;
    color: #818387;
    height: 36px;
    margin-bottom: 12px;
  }

  .table-row {
    display: grid;
    grid-template-columns: 5% 35% 25% 12% 6% 6% 6% 5%;
  }

  .table-row-project {
    display: grid;
    grid-template-columns: 5% 40% 30% 15% 10%;
  }

  .table-row-watching {
    display: grid;
    grid-template-columns: 5% 50% 30% 15%;
  }

  .table-row:hover {
    background-color: #EDEDED;
    cursor: pointer;
  }

  .table-row > div {
    display: flex;
    align-items: center;
    margin: 4px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .card-title-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

</style>


// WEBPACK FOOTER //
// src/components/shared_components/drawer/Drawer-List.vue